import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import s from './LinksList.scss';

class LinksList extends React.Component {
  render() {
    const { item } = this.props;
    return (
      <Link className={s['list-item']} to={item.wu} title={item.hl} spa>
        {item.hl}
      </Link>
    );
  }
}

LinksList.propTypes = {
  item: PropTypes.shape({}).isRequired,
};

export default LinksList;
